import { Flex, Typography } from '@aloft/toolkit-sui';

import { Value } from './types';
import { getStringValue } from './utils/getStringValue';

const MlsDataValueWithLabel = ({
  value,
  label,
  leftAlign,
  options,
}: {
  value?: Value | Value[];
  label: string;
  leftAlign?: boolean;
  options?: { noCommaInNumber: boolean };
}) => (
  <Flex
    justifyContent={leftAlign ? 'flex-start' : 'space-between'}
    width="100%"
    marginBottom=".5rem"
  >
    <Typography variant="body1" color="textTertiary">
      {`${label}${leftAlign ? ':' : ''}`}
    </Typography>
    <Flex marginLeft={leftAlign ? '10px' : undefined}>
      <Typography variant="body1" __dangerDoNotUseSx={{ textAlign: leftAlign ? 'left' : 'right' }}>
        {getStringValue(value ?? '-', options)}
      </Typography>
    </Flex>
  </Flex>
);

export default MlsDataValueWithLabel;
